module.exports = __webpack_public_path__ + "img/4_119.beac1848.png";